import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DOCUMENTS_API } from "./apiRoutes";

interface UseGetParkedListProps {
  communityId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getParkedList = async (data: any, communityId: string) =>
  await axiosAuth.post(`${DOCUMENTS_API(communityId)}/parked/grid`, data);

const useGetParkedList = ({
  data,
  communityId,
  queryParams,
}: UseGetParkedListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["parked-doc-list"],
    queryFn: () => getParkedList(data, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetParkedList;
